import cx from 'clsx';

import { labelTypeConfigMap } from './config';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ListTypeLabel: Component = ({
  type,
  labelSize,
  className,
  onClick,
}) => {
  const { labelText, labelClassName } = labelTypeConfigMap[type];

  return (
    <div
      className={cx(
        styles.containerLabel,
        styles[labelClassName],
        className,
      )}
      role="button"
      style={{
        fontSize: labelSize,
      }}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onClick}>
      {labelText}
    </div>
  );
};
